<template>
	<div class="school-user">
		<div class="tool-box">
			<el-button type="primary" size="small" @click="openAdd">新增用户</el-button>
			<el-button type="success" size="small" @click="openBatchAddUser">批量新增用户</el-button>
			<el-button size="small" @click="getLists">刷新列表</el-button>
			<el-button size="small" @click="getGenerateBySchool">导出免登二维码</el-button>
		</div>

		<div class="table-box">
			<el-table :data="list" border size="small" v-loading="loading" fit style="width: 100%;">
				<el-table-column prop="name" label="姓名" min-width="150" />
				<el-table-column prop="username" label="登录账号" min-width="180" />
				<el-table-column label="角色" min-width="120">
					<template slot-scope="{row}">
						<el-tag type="primary" v-if="row.roleType === 1">学校管理员</el-tag>
						<el-tag type="success" v-else>普通教师</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="账号状态" min-width="120">
					<template slot-scope="{row}">
						<el-tag :type="row.status === 0 ? 'success' : 'danger'">
							{{ row.status === 0 ? '正常' : '禁用' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="280">
					<template slot-scope="{row}">
						<el-button type="text" size="small" @click="handleResetPwd(row)">重置密码</el-button>
						<el-button type="text" size="small" style="color: red;" danger @click="handleDelete(row,1)"
							v-if="row.roleType === 0&&row.status===0">
							禁用
						</el-button>
						<el-button type="text" size="small" danger @click="handleDelete(row,0)"
							v-if="row.roleType === 0&&row.status===1">
							启用
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="page-box">
			<el-pagination :current-page="pageNum" :page-size="pageSize" :total="total"
				layout="total, prev, pager, next" @current-change="getList" />
		</div>

		<el-dialog title="用户编辑" :visible.sync="dialogVisible" width="520px" :append-to-body="true"
			 @close="dialogLoading = false">
			<el-form :model="form" :rules="editFormRules" label-width="100px" size="small" ref="editFormRef">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="form.name" placeholder="请输入教师姓名" maxlength="20">
						<span slot="suffix" style="
		            color:#999;
		            font-size:12px;
		            white-space:nowrap;
		            margin-left:6px;
		            display: flex;
		            align-items: center;
		          ">
							<span style="color: #409EFF;">{{ (form.name || '').length }}</span>/20
						</span>
						<template slot="prepend"></template>
					</el-input>
				</el-form-item>

				<el-form-item label="手机号码" prop="phone">
					<el-input v-model="form.phone" placeholder="选填，请输入11位手机号码" maxlength="11"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="批量新增教职工" :visible.sync="batchUserDialogVisible" width="500px" @close="resetUserBatch"
			:append-to-body="true">
			<div style="display:flex;gap:10px;justify-content:center;margin-bottom:15px;">
				<el-button type="primary" size="small" @click="downloadUserTemplate">下载教职工模板</el-button>
				<el-button type="success" size="small" @click="selectUserFile">上传Excel文件</el-button>
				<input ref="userFileRef" type="file" accept=".xlsx,.xls" style="display:none"
					@change="handleUserUpload" />
			</div>

			<!-- 预览列表（新增手机号列） -->
			<div v-if="userPreviewList.length > 0" style="border:1px solid #eee;padding:10px;border-radius:4px;">
				<div style="margin-bottom:8px;font-weight:bold;">已识别 {{ userPreviewList.length }} 名教职工</div>
				<el-table :data="userPreviewList" border size="mini" style="width:100%;">
					<el-table-column label="序号" type="index" align="center" width="60" />
					<el-table-column label="教职工姓名" prop="name" align="center" />
					<el-table-column label="手机号码" prop="phone" align="center" />
				</el-table>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="batchUserDialogVisible = false">取消</el-button>
				<el-button type="primary" :disabled="userPreviewList.length===0" @click="postSchoolUserBatchAdd">
					确认批量添加
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	const XLSX = require('xlsx');
	export default {
		components: {},
		name: 'SchoolUser',
		data() {
			return {
				loading: false,
				dialogLoading: false, // 编辑弹窗独立loading
				list: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				form: {},
				schoolId: localStorage.getItem('orgId'),
				showPassword: false,
				currentUser: {},

				batchUserDialogVisible: false,
				userPreviewList: [],
				// 国内手机号完整正则
				phoneReg: /^1(3[0-9]|4[4-9]|5[0-3,5-9]|6[2,5-7]|7[0-8]|8[0-9]|9[0-3,5-9])\d{8}$/,
				editFormRules: {
					name: [{
						required: true,
						message: '请输入教师姓名',
						trigger: 'blur'
					}],
					phone: [{
						validator: (rule, value, callback) => {
							const val = value ? value.trim() : ''
							if (val && !this.phoneReg.test(val)) {
								callback(new Error('手机号码格式不正确'))
							} else {
								callback()
							}
						},
						trigger: 'blur'
					}]
				},

			}
		},
		created() {
			this.getList()
		},
		methods: {
			getLists(){
				this.pageNum=1
				this.getList()
			},
			// 打开批量弹窗
			openBatchAddUser() {
				this.batchUserDialogVisible = true;
			},
			// 下载Excel模板（增加手机号列，备注可留空）
			downloadUserTemplate() {
				const data = [
					['序号', '教职工姓名', '手机号码（可留空，填写则必须为合法11位手机号）'],
				]
				const ws = XLSX.utils.aoa_to_sheet(data)
				const wb = XLSX.utils.book_new()
				XLSX.utils.book_append_sheet(wb, ws, '教职工')
				XLSX.writeFile(wb, '教职工批量导入模板.xlsx')
			},
			selectUserFile() {
				this.$refs.userFileRef.click()
			},
			// 文件上传解析 + 完整手机号号段校验
			handleUserUpload(e) {
				const file = e.target.files[0]
				if (!file) return

				const reader = new FileReader()
				reader.onload = ev => {
					const data = new Uint8Array(ev.target.result)
					const wb = XLSX.read(data, {
						type: 'array'
					})
					const sheet = wb.Sheets[wb.SheetNames[0]]
					const json = XLSX.utils.sheet_to_json(sheet, {
						header: ['xuhao', 'name', 'phone']
					})

					json.shift()
					const list = []
					for (let i = 0; i < json.length; i++) {
						const row = json[i]
						const name = row.name ? row.name?.trim() : ''
						const phone = row.phone ? String(row.phone).trim() : ''

						// 姓名必填校验
						if (!name) {
							this.$message.error(`第${i + 2}行：教职工姓名不能为空`)
							return
						}
						// 手机号有内容时，执行完整号段正则校验
						if (phone && !this.phoneReg.test(phone)) {
							this.$message.error(`第${i + 2}行：手机号【${phone}】不合法，请填写真实有效国内手机号，或留空不填`)
							return
						}
						list.push({
							name,
							phone
						})
					}

					if (list.length === 0) {
						this.$message.warning('未识别到有效教职工姓名，请检查文件！')
						return
					}
					this.userPreviewList = list
					this.$message.success(`识别到 ${list.length} 名教职工，手机号为空将不绑定登录账号`)
				}
				reader.readAsArrayBuffer(file)
			},
			resetUserBatch() {
				this.userPreviewList = []
				this.$refs.userFileRef && (this.$refs.userFileRef.value = '')
			},
			// 批量提交
			async postSchoolUserBatchAdd() {
				if (this.userPreviewList.length === 0) {
					this.$message.warning("请先上传并识别Excel文件");
					return;
				}
				this.loading = true;
				const batchData = this.userPreviewList.map(item => {
					return {
						name: item.name,
						phone: item.phone || '',
						schoolId: Number(this.schoolId)
					}
				})
				try {
					await this.API.post(this.API.school.postSchoolUserBatchAdd, batchData);
					this.$message.success("批量新增教职工成功！");
					this.batchUserDialogVisible = false;
					this.resetUserBatch();
					this.getList();
				} catch (err) {
					this.$message.error(err.response?.data?.msg || "批量新增失败，请检查文件或联系管理员");
					console.error(err);
				} finally {
					this.loading = false;
				}
			},

			// 下方原有所有方法完全保留，无改动
			async getGenerateBySchool() {
				try {
					let res = await this.API.getFileTypeGet(this.API.school.getGenerateBySchool, {
						schoolId: this.schoolId
					});
					let blob = new Blob([res.data], {
						type: "application/pdf"
					});
					let downloadUrl = URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = downloadUrl;
					a.download = "教师登陆二维码.pdf";
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					URL.revokeObjectURL(downloadUrl);
					this.$message.success("下载成功！");
				} catch (err) {
					this.$message.error("下载失败，请重试！");
					console.error(err);
				}
			},
			async getList(val) {
				if (val) {
					this.pageNum = val
				}
				this.loading = true
				try {
					const res = await this.API.get(this.API.school.getSchoolList, {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						schoolId: this.schoolId
					})
					this.list = res.data.data.records || []
					this.total = res.data.data.total
				} finally {
					this.loading = false
				}
			},
			openAdd() {
				this.form = {
					name: '',
					phone: '',
				}
				this.dialogVisible = true
			},
			openEdit(row) {
				this.form = {
					...row
				}
				this.form.roleType = 0
				this.dialogVisible = true
			},
			async save() {
				// 姓名非空校验
				if (!this.form.name || this.form.name.trim() === '') {
					this.$message.error('请输入教师姓名')
					return
				}
				// 手机号校验：不为空才校验格式
				const phone = this.form.phone ? this.form.phone.trim() : ''
				if (phone && !this.phoneReg.test(phone)) {
					this.$message.error('手机号码格式不正确，请输入合法11位手机号')
					return
				}

				this.dialogLoading = true // 只用弹窗独立loading
				try {
					const res = await this.API.post(this.API.school.postSchoolUserAdd, {
						name: this.form.name.trim(),
						phone: phone,
						schoolId: Number(this.schoolId)
					})
					this.$message.success('添加成功')
					this.dialogVisible = false
					this.getList()
				} finally {
					this.dialogLoading = false
				}
			},
			handleResetPwd(row) {
				this.$confirm('确定要将【' + row.name + '】的密码重置为默认密码吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					await this.API.post(this.API.school.postSchoolPwd, {
						id: row.id
					})
					this.$message.success('密码重置成功！默认密码：s88888888')
				}).catch(() => {
					this.$message.info('重置失败')
				})
			},
			async handleDelete(row, type) {
				var typename = type == 0 ? "启用" : '禁用'
				this.$confirm('确定要将【' + row.name + '】的状态设置为' + typename + '？', '提示', {
					confirmButtonText: typename,
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					await this.API.put(this.API.school.postSchoolStatus, {
						id: row.id,
						status: type
					})
					this.$message.success(`${row.name}用户状态${typename}成功`)
					this.getList()
				}).catch(() => {
					this.$message.info(`${typename}失败`)
				})
			}
		}
	}
</script>

<style scoped>
	.school-user {
		width: calc(80vw);
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.tool-box {
		margin-bottom: 12px;
	}

	.table-box {
		flex: 1;
		overflow: auto;
		min-height: 200px;
		width: 100%;
	}

	.page-box {
		margin-top: 12px;
		text-align: right;
	}

	/deep/ .el-input__suffix {
		display: flex !important;
		align-items: center !important;
		height: 100%;
	}

	/* 给输入框留出右侧空间，避免文字遮挡计数 */
	/deep/ .el-input__inner {
		padding-right: 65px;
	}
	
	/* 强制弹窗外层容器全局最高层级，碾压表格loading遮罩 */
	/deep/ .el-dialog__wrapper {
	  z-index: 9999 !important;
	}
	/* 弹窗背景遮罩层级略低于弹窗内容 */
	/deep/ .el-overlay-dialog {
	  z-index: 9998 !important;
	}
	/* 表格loading遮罩强制压低层级，永远无法覆盖弹窗 */
	/deep/ .el-loading-mask {
	  z-index: 1000 !important;
	}
</style>